import { render, staticRenderFns } from "./myAttendance.vue?vue&type=template&id=56a5e415&"
import script from "./myAttendance.vue?vue&type=script&lang=js&"
export * from "./myAttendance.vue?vue&type=script&lang=js&"
import style0 from "./myAttendance.vue?vue&type=style&index=0&id=56a5e415&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports